import { render } from "./PopUpLogin.vue?vue&type=template&id=6d01b70f"
import script from "./PopUpLogin.vue?vue&type=script&lang=js"
export * from "./PopUpLogin.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\git\\CatalogOnVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__